<template>
<div>
    <div v-if="loading">
        <div class="spinner-grow spinner-grow-sm loading-spinner" role="status">
        </div>
    </div>
    <div v-else-if="translation" class="translation-for-definition">
        {{ translation }}   
    </div>
    <div v-else-if="error">
        {{ error }}
    </div>
    <div v-else-if="isQuotaError">
        {{ error }}
    </div>
    <font-awesome-icon v-else :icon="'language'" @click="translate()" class="language-icon" v-tooltip="'Translate this definition'"/>
</div>
</template>
<script>
import {mapMutations, mapState} from 'vuex'
import axios from 'axios';


export default {
  name: 'ResultTranslation',
  props: {
    columnName: {type: String, required: true},
    tibetanText: {type: String, required: true},
  },
  data() {
    return {
        error: null,
        isQuotaError: false,
        loading: false,
        translation: null,
    }
  },
  computed: {
    ...mapState('app', [
    ]),
  },
  methods: {
    ...mapMutations([
    ]),
      async translate() {
          console.log(`Translating ${this.columnName}:` + this.tibetanText)
          // Reset state
          this.translation = null;
          this.error = null;
          this.isQuotaError = false;
          this.loading = true;

          try {

              if (this.tibetanText && this.tibetanText.length > 0) {

                  // Include dictionary context when results are provided
                  const prompt = `Translate the following Classical Tibetan text to English. Provide a natural, fluent translation that captures the meaning while staying accurate to the original grammar as much as possible. Only provide the translation, no explanation or additional commentary. DO NOT SKIP ANY PART OF THE TEXT.:\n\n${this.tibetanText}`;

                  console.log("Dictionary result translation prompt:", prompt);

                  const userApiKey = this.$store.state.app.userGeminiApiKey;

                  const response = await axios.post(this.$server.apiUrl + '/api/gemini/query', {
                      prompt: prompt,
                      userApiKey: userApiKey,
                      options: {
                          temperature: 0.3,
                          maxOutputTokens: 1000,
                      }
                  });

                  if (response.data && response.data.text) {
                      this.translation = response.data.text.trim();
                  } else {
                      this.error = 'No translation received from AI service';
                  }
              }
              else {
                console.error("tibetanText is empty or undefined:", this.tibetanText)
              }

          } catch (error) {
              this.$log.error('Gemini API error:', error);

              // Handle quota exceeded errors (429 status)
              if (error.response && error.response.status === 429) {
                  const errorData = error.response.data;

                  if (errorData && errorData.isQuotaError) {
                      //const retryAfter = errorData.retryAfter || 86400; // Default to 24 hours
                      //const retryTime = new Date(Date.now() + retryAfter * 1000);
                      //const hoursUntilReset = Math.ceil(retryAfter / 3600);

                      this.error = `Free translation quote exceeded.`;
                      this.isQuotaError = true;
                  } else {
                      this.error = 'Rate limit exceeded. Please try again in a moment.';
                  }
              } else if (error.response && error.response.data && error.response.data.error) {
                  this.error = error.response.data.error;
              } else {
                  this.error = 'Failed to generate AI translation. Please try again. Error:' + error.message;
              }
          } finally {
              this.loading = false;
          }
      },
  }
}

</script>
<style>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .language-icon {
    float: right;
    position: relative;
    top: -10px;
    color: lightblue;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .language-icon:hover {
    color: #1e90ff;
    transform: scale(1.15) translateY(-2px);
    filter: drop-shadow(0 4px 8px rgba(30, 144, 255, 0.3));
  }

  .language-icon:active {
    transform: scale(1.1) translateY(0);
  }
  .loading-spinner {
    margin: 10px 10px 0px;
  }
  .translation-for-definition {
    font-size: 1.1rem;
    margin-top:10px;
  }
</style>
